"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralBusinessDetailSchema = exports.OthersBusinessSchema = exports.ProductBusinessSchema = exports.PlantBusinessSchema = exports.AnimalBusinessSchema = exports.BusinessGenericSchema = exports.GeneralBusinessProfileSchema = exports.BusinessTemplateSchema = exports.OthersBusinessDetailSchema = exports.ProductBusinessDetailSchema = exports.ProductsSubIndustrySchema = exports.PlantBusinessDetailSchema = exports.PlantsSubIndustrySchema = exports.AnimalBusinessDetailSchema = exports.AnimalServiceSchema = exports.AnimalsSubIndustrySchema = exports.IndustryTypeSchema = exports.BusinessMemberSchema = exports.LocationSchema = exports.ArgentinaLocationSchema = exports.CanadaLocationSchema = exports.AustraliaLocationSchema = exports.SupportedCountries = exports.CountrySchema = exports.NlisDetailSchema = exports.BasicLocationSchema = exports.CoordinateSchema = exports.TagAlertStandardSchema = exports.AngusProfileSchema = exports.PropertySchema = exports.PermitSchema = void 0;
const zod_1 = require("zod");
const user = __importStar(require("../misc/user"));
const TokenMisc = __importStar(require("../misc/token"));
const BrandMisc = __importStar(require("../misc/brand"));
//Permit
exports.PermitSchema = zod_1.z.object({
    permitNumber: zod_1.z.string(),
    permitExpiryDate: zod_1.z.string(),
    permitID: zod_1.z.string(),
});
//Property
exports.PropertySchema = zod_1.z.object({
    name: zod_1.z.string(),
    picNum: zod_1.z.string(),
    address: zod_1.z.string(),
    town: zod_1.z.string(),
    postcode: zod_1.z.string(),
    country: zod_1.z.string(),
    state: zod_1.z.string(),
});
//Angus Profile
exports.AngusProfileSchema = zod_1.z.object({
    businessName: zod_1.z.string(),
    abn: zod_1.z.string(),
    angusAuthToken: zod_1.z.string(),
    acctID: zod_1.z.string(),
    NLISUserID: zod_1.z.string(),
    NLISPassword: zod_1.z.string(),
    angusTechUsername: zod_1.z.string(),
    angusTechPassword: zod_1.z.string(),
    isVerifiedProducer: zod_1.z.boolean(),
    properties: zod_1.z.array(exports.PropertySchema),
});
//Tag Alert Standard
exports.TagAlertStandardSchema = zod_1.z.object({
    activityLevel: zod_1.z.object({
        no: zod_1.z.boolean(),
        low: zod_1.z.boolean(),
        medium: zod_1.z.boolean(),
        high: zod_1.z.boolean(),
        extreme: zod_1.z.boolean(),
    }),
    location: zod_1.z.boolean(),
    inactive: zod_1.z.boolean()
});
//Coordinate
exports.CoordinateSchema = zod_1.z.object({
    lat: zod_1.z.number(),
    lng: zod_1.z.number()
});
//Basic Location
exports.BasicLocationSchema = zod_1.z.object({
    locationNickname: zod_1.z.string(),
    locationType: zod_1.z.string(),
    locationId: zod_1.z.string(),
    PICAddress: zod_1.z.string(),
    renspa: zod_1.z.string().optional(),
    address: zod_1.z.string(),
    postcode: zod_1.z.string(),
    town: zod_1.z.string(),
    LPAUserID: zod_1.z.string(),
    LPAPassword: zod_1.z.string(),
    NLISUserID: zod_1.z.string(),
    NLISPassword: zod_1.z.string(),
    geofence: zod_1.z.array(exports.CoordinateSchema).optional(),
    tagAlertStandard: exports.TagAlertStandardSchema.optional(),
});
//NLIS Details
exports.NlisDetailSchema = zod_1.z.object({
    nlisUserId: zod_1.z.string(),
    nlisPassword: zod_1.z.string(),
    nlisEmail: zod_1.z.string()
});
//Country
exports.CountrySchema = zod_1.z.enum(['Australia', 'Canada', 'Argentina']);
//required const assertions to translate to zod schema
//export as regular variable to be used for display
exports.SupportedCountries = {
    Australia: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
    Canada: ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'QC', 'ON', 'PE', 'SK', 'YT'],
    Argentina: ['Capital Federal', 'Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba', 'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'],
};
//Australia Location
exports.AustraliaLocationSchema = zod_1.z.object({
    country: zod_1.z.literal(exports.CountrySchema.enum.Australia).optional(),
    state: zod_1.z.enum(exports.SupportedCountries.Australia),
}).merge(exports.BasicLocationSchema);
//Canada Location
exports.CanadaLocationSchema = zod_1.z.object({
    country: zod_1.z.literal(exports.CountrySchema.enum.Canada),
    state: zod_1.z.enum(exports.SupportedCountries.Canada)
}).merge(exports.BasicLocationSchema);
//Argentina Location
exports.ArgentinaLocationSchema = zod_1.z.object({
    country: zod_1.z.literal(exports.CountrySchema.enum.Argentina),
    state: zod_1.z.enum(exports.SupportedCountries.Argentina)
}).merge(exports.BasicLocationSchema);
exports.LocationSchema = zod_1.z.union([exports.AustraliaLocationSchema, exports.CanadaLocationSchema, exports.ArgentinaLocationSchema]);
//Business Member
exports.BusinessMemberSchema = zod_1.z.object({
    name: user.NameSchema,
    role: zod_1.z.enum(['user', 'admin']),
    email: user.EmailSchema,
    phone: user.PhoneNumberSchema,
    userId: zod_1.z.string(),
    invitationCode: zod_1.z.string().optional(),
    invitationDate: zod_1.z.union([zod_1.z.date().nullable(), zod_1.z.string()]),
    addedDate: zod_1.z.union([zod_1.z.date().nullable(), zod_1.z.string()]),
    deactivatedDate: zod_1.z.union([zod_1.z.date().nullable().optional(), zod_1.z.string()]),
    status: zod_1.z.string().optional()
});
//Misc
const OptiweighBusinessSchema = zod_1.z.object({
    clientId: zod_1.z.string(),
    apiKey: zod_1.z.string(),
    agliveKey: zod_1.z.string(),
    interval: zod_1.z.string(),
});
//Industrial Type
exports.IndustryTypeSchema = zod_1.z.enum(['ANIMALS', 'PLANTS', 'PRODUCTS', 'LOGISTICS', 'SERVICES', 'BUYER']);
//Industrial Type - ANIMALs
exports.AnimalsSubIndustrySchema = zod_1.z.enum(['Cattle', 'Sheep', 'Goats', 'Pigs', 'Horses', 'Chickens', 'Fish']);
exports.AnimalServiceSchema = zod_1.z.enum(['Producer', 'Agent', 'Saleyard', 'Feedlot', 'Vet', 'Processor']);
exports.AnimalBusinessDetailSchema = zod_1.z.object({
    industryType: zod_1.z.literal(exports.IndustryTypeSchema.enum.ANIMALS),
    subIndustryType: exports.AnimalsSubIndustrySchema,
    businessScope: exports.AnimalServiceSchema,
    businessType: zod_1.z.literal("Angus").optional(),
    angusProfile: exports.AngusProfileSchema.optional(),
    optiweigh: OptiweighBusinessSchema.optional(),
    agentNumber: zod_1.z.string().optional()
});
//Industrial Type - PLANT
exports.PlantsSubIndustrySchema = zod_1.z.enum(['Cannabis', 'Hemp', 'Fruit', 'Vegetable', 'Wheat', 'Rice']);
exports.PlantBusinessDetailSchema = zod_1.z.object({
    industryType: zod_1.z.literal(exports.IndustryTypeSchema.enum.PLANTS),
    subIndustryType: exports.PlantsSubIndustrySchema,
    licenseNumber: zod_1.z.string(),
    licenseExpiryDate: zod_1.z.string(),
    permits: zod_1.z.array(exports.PermitSchema)
});
//Industrial Type - PRODUCT
exports.ProductsSubIndustrySchema = zod_1.z.enum(['Alcohol', 'Drinks', 'Meat', 'Fish', 'Dairy', 'Vitamins']);
exports.ProductBusinessDetailSchema = zod_1.z.object({
    industryType: zod_1.z.literal(exports.IndustryTypeSchema.enum.PRODUCTS),
    subIndustryType: exports.ProductsSubIndustrySchema,
});
//Industrial Type - OTHER
exports.OthersBusinessDetailSchema = zod_1.z.object({
    industryType: zod_1.z.enum([
        exports.IndustryTypeSchema.enum.BUYER,
        exports.IndustryTypeSchema.enum.LOGISTICS,
        exports.IndustryTypeSchema.enum.SERVICES
    ])
});
exports.BusinessTemplateSchema = zod_1.z.object({
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    docId: zod_1.z.string(),
    status: zod_1.z.string()
});
//Business Profile
exports.GeneralBusinessProfileSchema = zod_1.z.object({
    businessCountry: exports.CountrySchema.optional(),
    companyName: zod_1.z.string(),
    companyNumber: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    brandDescription: zod_1.z.string(),
    imageUri: zod_1.z.string().optional(),
    cuig: zod_1.z.string().optional(),
    location: zod_1.z.array(exports.LocationSchema).optional(),
    users: zod_1.z.array(exports.BusinessMemberSchema).optional(),
    externalIds: TokenMisc.ExternalIdsSchema.optional(),
    template: zod_1.z.array(exports.BusinessTemplateSchema).optional(),
    //below are all fields belonging to specific industries, made optional to not error in TS
    brands: zod_1.z.array(BrandMisc.BrandSchema).optional(),
});
const AlertTypeSchema = zod_1.z.enum(['email', 'sms']);
exports.BusinessGenericSchema = exports.GeneralBusinessProfileSchema
    .merge(zod_1.z.object({
    alerts: zod_1.z.set(AlertTypeSchema).optional(),
}));
exports.AnimalBusinessSchema = exports.AnimalBusinessDetailSchema.merge(exports.BusinessGenericSchema);
exports.PlantBusinessSchema = exports.PlantBusinessDetailSchema.merge(exports.BusinessGenericSchema);
exports.ProductBusinessSchema = exports.ProductBusinessDetailSchema.merge(exports.BusinessGenericSchema);
exports.OthersBusinessSchema = exports.OthersBusinessDetailSchema.merge(exports.BusinessGenericSchema);
exports.GeneralBusinessDetailSchema = zod_1.z.union([exports.AnimalBusinessSchema, exports.PlantBusinessSchema, exports.ProductBusinessSchema, exports.OthersBusinessSchema]);
